export const errorMessages = {
  incorrectCredentials: 'Usuário e/ou senha incorretos.',
  userIsBlocked: 'Usuário bloqueado por excesso de tentativas incorretas.',
  unauthorizedProfile: 'Usuário não possui acesso à plataforma, por favor, contate o suporte.'
}
